import React from 'react';
import { CELL_ALIGN } from '~/web-frontend-core/api/const/base';
export const THead = React.memo((props) => <tr>
      {props.rows.map((cell, i, row) => <th key={`${cell.txt}_${i}`} className={`g-t-v-th-a-c align-${cell.al || CELL_ALIGN.LEFT} ${i === 0 ? 'padding-l' : ''}`} style={props.getColumnStyle(i, row)} rowSpan={cell.rs} colSpan={cell.cs} title={cell.txt}>
            {cell.txt}
         </th>)}
   </tr>);



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/outcomes/additional/tables/THead.jsx